<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-if="type === 'icon'" class="mr-4" v-bind="attrs" fab small text v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
        <app-btn v-else outlined v-bind="attrs" rounded v-on="on"> Opções </app-btn>
      </template>
      <v-list dense>
        <v-list-item @click="handleCustomerExport()">
          <v-list-item-avatar>
            <app-icon>download </app-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Exportar </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="handleCustomerImportSection()">
          <v-list-item-avatar>
            <app-icon>upload</app-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Importar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isProfessional" @click="copySelfRegistrationLink()">
          <v-list-item-avatar>
            <app-icon>mdi-link-variant</app-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Link de cadastro</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <CustomerImportSection ref="CustomerImportSection" />
  </div>
</template>

<script>
import CustomerImportSection from "@/components/customers/sections/CustomerImportSection.vue";
import { customerAlias } from "@/utils/customerAlias";

export default {
  components: {
    CustomerImportSection,
  },
  props: {
    type: {
      type: String,
      default: "btn",
      validator: (value) => ["btn", "icon"].includes(value),
    },
  },
  computed: {
    isProfessional() {
      const companyUser = this.$store.state.auth.company_user;

      return !!(companyUser && companyUser.is_professional);
    },
  },
  methods: {
    copySelfRegistrationLink() {
      const uid = this.$store.state.auth.user.uid;

      const link = `${window.location.origin}/cadastro-paciente/${uid}`;

      navigator.clipboard.writeText(link);

      this.$snackbar({
        message: "Link copiado para a área de transferência",
        color: "success",
        timeout: 1500,
        showClose: false,
      });
    },
    handleCustomerExport() {
      this.$http
        .download("customer/customers-export")
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${customerAlias()}s.xlsx`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleCustomerImportSection() {
      this.$refs.CustomerImportSection.open();
    },
  },
};
</script>

<style>
</style>